import React from 'react';
import { Modal, Button, Col, Row } from 'react-bootstrap';
import { Icon, Aux } from './';
import "../../../assets/scss/modal-confirm.scss";

const ConfirmModal = props => {
    const { className, variant, title, iconClassName,
        cancelButton, confirmButton, onHide, onConfirm, onCancel, hideCloseIcon = false, inactiveButton } = props;
    const show = props.hasOwnProperty("isOpen") ? props.isOpen : props.show;
    const content = props.content ? props.content : props.body;
    const variantClassName = variant ? `modal-${variant}` : "modal-danager";

    return (<Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        className={`modal-confirm  ${variantClassName || ''} ${className || ''}`}>
        <Modal.Header closeButton={!hideCloseIcon}>
            <Aux className="icon-box">
                <Icon className={iconClassName} />
            </Aux>
            <Modal.Title className={title && title.className}>
                {title && title.content ? title.content : "Are you sure?"}
            </Modal.Title>
        </Modal.Header>
        {content && <Modal.Body>
            <Row>
                <Col>{content}</Col>
            </Row>
        </Modal.Body>}

        <Modal.Footer className='p-0'>
            <Button
                size="sm"
                variant={cancelButton && cancelButton.variant ? cancelButton.variant : "default"}
                className={`${cancelButton && cancelButton.className ? cancelButton.className : ''}`}
                onClick={(e) => {
                    if (onCancel) onCancel(e);
                    else onHide();
                }}>
                {cancelButton && cancelButton.content ? cancelButton.content : "No"}
            </Button>

            {inactiveButton &&
                <Button
                    size="sm"
                    className={`${inactiveButton && inactiveButton.className ? inactiveButton.className : ''} warning`}
                    variant={inactiveButton && inactiveButton.variant ? inactiveButton.variant : "warning"}
                    onClick={(e) => {
                        if (inactiveButton.onInActive) inactiveButton.onInActive(e);
                        onHide();
                    }}>
                    {inactiveButton.content ? inactiveButton.content : "Remove"}
                </Button>}

            <Button
                size="sm"
                className={`${confirmButton && confirmButton.className ? confirmButton.className : ''}`}
                variant={confirmButton && confirmButton.variant ? confirmButton.variant : "danger"}
                onClick={(e) => {
                    if (onConfirm) onConfirm(e);
                    onHide();
                }}>
                {confirmButton && confirmButton.content ? confirmButton.content : "Yes"}
            </Button>
        </Modal.Footer>

    </Modal>);
};

Modal.Confirm = ConfirmModal;

export default Modal;